import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "row no-gutters pt-45 pb-sm-9 pb-7" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", { class: "h5-responsive mb-1" }, "Hast Du Fragen?", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-1" }, "Dann hilft unser Customer Support gern weiter.", -1);
const _hoisted_5 = {
    key: 0,
    class: "font7-responsive"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("a", {
    href: "mailto:support@myswooop.de",
    title: "Schreib Michelle",
    class: "link-in-text"
}, " support@myswooop.de ", -1);
const _hoisted_7 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-12 d-flex\"><div class=\"\" style=\"display:flex;justify-content:space-evenly;align-items:center;\"><img src=\"/images/_new_brand/product_detail_page/support_michelle.png\" width=\"79\" height=\"79\" alt=\"Customer Service\" class=\"mr-2 ml-md-3\"><p class=\"text-left mb-0 font6-responsive\"><i class=\"icon-brand_email\"></i><a href=\"mailto:support@myswooop.de\" title=\"Schreib Michelle\">support@myswooop.de</a><br><i class=\"icon-brand_phone\"></i><a href=\"tel:+49 (0) 421 98 96 87 0\" title=\"mySWOOOP Telefonnummer\">+49 (0) 421 98 96 87 0</a><br><i class=\"icon-brand_clock\"></i> Mo-Fr 09:00 - 17:00 </p></div></div>", 1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            (_ctx.possiblyLate)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                    _createTextVNode(" Aktuell kommt es zu einem stark erhöhtem Anrufaufkommen und damit zu längerer Wartezeit. Schreibe uns daher am besten eine E-Mail an "),
                    _hoisted_6,
                    _createTextVNode(" - wir melden uns schnellstmöglich bei dir zurück! ")
                ]))
                : _createCommentVNode("", true)
        ]),
        _hoisted_7
    ]));
}
